
import { Power1, TimelineMax, Bounce } from "gsap";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";

import { Point, IPoint } from "pixi.js";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { PunkGameConfig } from "../../../../PunkGameConfig";
import { WinCounter } from "../../../independent/countup/WinCounter";
import { PunkEngineManager } from "../../../../punkEngine/PunkEngineManager";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { PunkCounter } from "../../../independent/countup/PunkCounter";

export class NormalWinCountUp extends PunkCounter {

    constructor() {
        super({
            font : {
                name : "NumbersWinCountUp",
                size : 46
            },
            tint : parseInt(("#ffffff").replace(/^#/, ''), 16)
        });

        this._countUp.maxTextWidth = PunkEngineManager.ReelAreaWidth/1.35;
        this.zIndex = 0;
        StageManager.getLayer(PunkGameConfig.instance.LAYERS.WIN_COUNT_UP.name).addChild(this);
    }

    public get counterBit():PIXI.Container{
        return this._countUp;
    }

    public showCounter(to?:number):void {
        this._countUp.alpha = 1;
        this._countUp.scale.set(1, 1);
        if(to != undefined) this._countUp.showValue(to,true);
    }

    public getCountUpAnimation(from:number, to:number, duration:number):TimelineMax {
        const deciNumber:number = MathHelper.floorToDecimals(to,2);
        this._timeline = Helper.timeLineKiller(this._timeline!, new TimelineMax({onComplete:() => this.showCounter(to)}));
        this._timeline.add(() => this._countUp.alpha = 1);
        this._timeline.add(this._countUp.getCountUpAnimation(from, deciNumber, {duration : duration, ease : Power1.easeInOut}));
        return this._timeline;
    }

    public playSizing(duration:number, factor:number = 1):TimelineMax {
        const timeline:TimelineMax = new TimelineMax();
        const scaleOrigin:IPoint = new Point(this._countUp.scale.x,this._countUp.scale.y);
        timeline.to(this._countUp.scale,duration*0.25,{x:scaleOrigin.x * (1.1*factor),y:scaleOrigin.y * (1.1*factor)});
        timeline.to(this._countUp.scale,duration*0.75,{x:scaleOrigin.x,y:scaleOrigin.y,ease:Bounce.easeOut});
        return timeline;
    }

    public abort(endValue:number,hideCounter:boolean = false):void {
        if(hideCounter)
            this._countUp.alpha = 0;
        else{
            if(endValue != undefined) this._countUp.showValue(endValue,true);
            if(this._countUp.alpha == 0) return;
            WinCounter.winWayCounter.waysWonHide();
            this._timeline = Helper.timeLineKiller(this._timeline as TimelineMax, new TimelineMax());
            this._countUp.alpha = 1;
            this._timeline.delay(0.6);
            this._timeline.fromTo(this._countUp, 0.2,{alpha : 1}, {alpha : 0}); // stay a while after count up.
        }
    }

    public onResize(xOffset:number = 0):void{
        if(this._countUp.alpha == 0) this.position = new Point(360+xOffset,360);
    }
}